<template>
  <div :class="{
    'mui-snackbar': true,
    'mui-snackbar--active': active }">
    <div
      class="mui-snackbar__text">
      <div>{{notification && notification.message}}</div>
    </div>
  </div>
</template>

<script>
// TODO:
// - Handle multiple notifications shown synchronously
// - Use Vue transitions
import { POP_NOTIFICATION } from '../modules/mutation-types'

export default {
  data () {
    return {
      active: false,
      notification: {
        message: null
      },
      timeoutClose: 2750,
      timeoutOpen: 400
    }
  },
  computed: {
    notifications () {
      return this.$store.state.app.notifications
    }
  },
  watch: {
    notifications () {
      if (this.notifications.length > 0 && !this.active) {
        setTimeout(() => {
          this.notification = this.notifications[0]
          this.active = true
          setTimeout(() => {
            this.active = false
            this.$store.commit(POP_NOTIFICATION)
          }, this.timeoutClose)
        }, this.timeoutOpen)
      }
    }
  }
}
</script>

<style lang="sass">
@import "../styles/variables.scss"
.mui-snackbar
  display: flex
  position: fixed
  bottom: 0
  left: 50%
  align-items: center
  justify-content: flex-start
  box-sizing: border-box
  padding: 19px 24px 20px
  transform: translate(-50%, calc(100% + 12px))
  transition: -webkit-transform 0.25s 0ms cubic-bezier(0.4, 0, 1, 1)
  transition: transform 0.25s 0ms cubic-bezier(0.4, 0, 1, 1)
  transition: transform 0.25s 0ms cubic-bezier(0.4, 0, 1, 1), -webkit-transform 0.25s 0ms cubic-bezier(0.4, 0, 1, 1)
  background-color: #232323
  border-radius: 6px
  margin-bottom: 12px
  pointer-events: none
  will-change: transform
  z-index: 10000
  .device__viewport-class--regular &
    min-width: 288px
    max-width: 568px
  .device__viewport-class--compact &
    min-width: calc(100% - 24px)
    max-width: calc(100% - 24px)
.mui-snackbar--active
  transform: translate(-50%, 0)
  transition: -webkit-transform 0.25s 0ms cubic-bezier(0, 0, 0.2, 1)
  transition: transform 0.25s 0ms cubic-bezier(0, 0, 0.2, 1)
  transition: transform 0.25s 0ms cubic-bezier(0, 0, 0.2, 1), -webkit-transform 0.25s 0ms cubic-bezier(0, 0, 0.2, 1)
  pointer-events: auto
.mui-snackbar__text
  font-family: $uiFontFamily
  -moz-osx-font-smoothing: grayscale
  -webkit-font-smoothing: antialiased
  font-size: 1rem
  font-weight: 400
  text-decoration: inherit
  text-transform: inherit
  margin-left: 0
  margin-right: auto
  display: flex
  align-items: center
  transition: opacity 0.3s 0ms cubic-bezier(0.4, 0, 1, 1)
  opacity: 0
  color: white
  .mui-snackbar--active &
    opacity: 1
</style>



// WEBPACK FOOTER //
// src/components/MUISnackbar.vue